module.exports = ['$resource', function ( $resource ) {

	let Item = $resource('/templateitems/:id',
		{
			id: '@id'
		},
		{
			'save': {method:'POST'},
			'update': {method: 'PATCH'}
		}
	);

	var save = Item.save;

	// Required for "easy" .save in controllers
	Item.save = function ( ...args ) {

		if( args[0].id ) {
			this.update.apply(this, args);
		} else {
			save.apply(this, args);
		}
	};

	return Item;
} ];
